import styled from 'styled-components';
import { Switch } from '@perch-labs/shrike';

export const PlanSwitch = styled(Switch).attrs({
  width: '100%',
  margin: { bottom: '24px' },
})`
  > label {
    font-size: ${props => props.theme.fontSizes[400]};
    font-family: ${props => props.theme.fontFamilies.main.medium};
    line-height: ${props => props.theme.lineHeights.small};
  }
`;

export const AllPlansSwitch = styled(Switch).attrs({
  width: '100%',
})`
  > label {
    font-family: ${props => props.theme.fontFamilies.main.regular};
  }
`;
